export const environment = {
  production: true,
  urlApi: "https://api.pentviewdev.com",
  urlCrmWs: "https://api.pentviewdev.com",
  languages: ["en", "es", "de", "ar", "zh-CN", "zh-TW", "he", "ru"],
  password: "bC#4nj_HM",
};
